import type { Widget } from "@emkit/builder-core";
import type { ComponentType } from "react";

import { AccordionInspector } from "./AccordionInspector.js";
import { AlertInspector } from "./AlertInspector.js";
import { AudioInspector } from "./AudioInspector.js";
import { BadgeInspector } from "./BadgeInspector.js";
import { BreadcrumbsInspector } from "./BreadcrumbsInspector.js";
import { ButtonInspector } from "./ButtonInspector.js";
import { CarouselInspector } from "./CarouselInspector.js";
import { ChartInspector } from "./ChartInspector.js";
import { CodeInspector } from "./CodeInspector.js";
import { CountdownInspector } from "./CountdownInspector.js";
import { CtaBannerInspector } from "./CtaBannerInspector.js";
import { DividerInspector } from "./DividerInspector.js";
import { FaqInspector } from "./FaqInspector.js";
import { FeaturesInspector } from "./FeaturesInspector.js";
import { FormInspector } from "./FormInspector.js";
import { GalleryInspector } from "./GalleryInspector.js";
import { HeadingInspector } from "./HeadingInspector.js";
import { HeroInspector } from "./HeroInspector.js";
import { HtmlInspector } from "./HtmlInspector.js";
import { IconListInspector } from "./IconListInspector.js";
import { ImageInspector } from "./ImageInspector.js";
import { LogoBarInspector } from "./LogoBarInspector.js";
import { MapInspector } from "./MapInspector.js";
import { NavMenuInspector } from "./NavMenuInspector.js";
import { NewsletterInspector } from "./NewsletterInspector.js";
import { PricingInspector } from "./PricingInspector.js";
import { ProductCardInspector } from "./ProductCardInspector.js";
import { ProgressInspector } from "./ProgressInspector.js";
import { QuoteInspector } from "./QuoteInspector.js";
import { ShareInspector } from "./ShareInspector.js";
import { SocialLinksInspector } from "./SocialLinksInspector.js";
import { SpacerInspector } from "./SpacerInspector.js";
import { StatsInspector } from "./StatsInspector.js";
import { StepsInspector } from "./StepsInspector.js";
import { TabsInspector } from "./TabsInspector.js";
import { TeamInspector } from "./TeamInspector.js";
import { TestimonialsInspector } from "./TestimonialsInspector.js";
import { TextInspector } from "./TextInspector.js";
import { TimelineInspector } from "./TimelineInspector.js";
import { VideoInspector } from "./VideoInspector.js";

export interface WidgetInspectorProps {
  widget: Widget;
}

const map: Record<string, ComponentType<WidgetInspectorProps>> = {
  heading: HeadingInspector,
  text: TextInspector,
  image: ImageInspector,
  button: ButtonInspector,
  spacer: SpacerInspector,
  divider: DividerInspector,
  video: VideoInspector,
  html: HtmlInspector,
  form: FormInspector,
  accordion: AccordionInspector,
  tabs: TabsInspector,
  gallery: GalleryInspector,
  "icon-list": IconListInspector,
  hero: HeroInspector,
  pricing: PricingInspector,
  testimonials: TestimonialsInspector,
  stats: StatsInspector,
  features: FeaturesInspector,
  "logo-bar": LogoBarInspector,
  "cta-banner": CtaBannerInspector,
  faq: FaqInspector,
  alert: AlertInspector,
  quote: QuoteInspector,
  "social-links": SocialLinksInspector,
  progress: ProgressInspector,
  badge: BadgeInspector,
  code: CodeInspector,
  map: MapInspector,
  countdown: CountdownInspector,
  breadcrumbs: BreadcrumbsInspector,
  "nav-menu": NavMenuInspector,
  share: ShareInspector,
  audio: AudioInspector,
  chart: ChartInspector,
  team: TeamInspector,
  steps: StepsInspector,
  timeline: TimelineInspector,
  newsletter: NewsletterInspector,
  carousel: CarouselInspector,
  "product-card": ProductCardInspector,
};

export function inspectorFor(
  type: string,
): ComponentType<WidgetInspectorProps> | undefined {
  return map[type];
}
